import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
(function(IBadge) {
    (function(BadgeType) {
        BadgeType["BADGE_TYPE_UNKNOWN"] = "BADGE_TYPE_UNKNOWN";
        BadgeType["NEW_BADGE"] = "NEW_BADGE";
        BadgeType["HIGH_SELL_THROUGH"] = "HIGH_SELL_THROUGH";
        BadgeType["BESTSELLER"] = "BESTSELLER";
        BadgeType["TOP_SHOP"] = "TOP_SHOP";
        BadgeType["SHOWROOM"] = "SHOWROOM";
        BadgeType["PREVIOUSLY_ORDERED"] = "PREVIOUSLY_ORDERED";
        BadgeType["PREORDER"] = "PREORDER";
        BadgeType["BRAND_BESTSELLER"] = "BRAND_BESTSELLER";
        BadgeType["FAIRE_BESTSELLER"] = "FAIRE_BESTSELLER";
        /**
     * @deprecated
     */ BadgeType["HIGH_SELL_THROUGH_V4"] = "HIGH_SELL_THROUGH_V4";
        /**
     * @deprecated
     */ BadgeType["HIGH_SELL_THROUGH_V5"] = "HIGH_SELL_THROUGH_V5";
        BadgeType["HIGH_SELL_THROUGH_V6"] = "HIGH_SELL_THROUGH_V6";
        BadgeType["TRENDING"] = "TRENDING";
        /**
     * Backend only: should not be exposed to clients, should be converted to TRENDING if returned to clients.
     */ BadgeType["INTERNAL_TRENDING_NAM"] = "INTERNAL_TRENDING_NAM";
        /**
     * Backend only: should not be exposed to clients, should be converted to TRENDING if returned to clients.
     */ BadgeType["INTERNAL_TRENDING_EUROPE"] = "INTERNAL_TRENDING_EUROPE";
    })(IBadge.BadgeType || (IBadge.BadgeType = {}));
    IBadge.build = function(partial) {
        return _object_spread({
            xp_settings: []
        }, partial !== null && partial !== void 0 ? partial : {});
    };
})(IBadge || (IBadge = {}));
export var IBadge;
